import Image from 'next/image'
import NextLink from 'next/link'
import { memo } from 'react'
import { twMerge } from 'tailwind-merge'

type Props = {
  className?: string
  size?: string
} & React.ComponentPropsWithoutRef<'div'>

const LogoImage = memo(({ src, className, size }: { src: string; className: string; size?: string }) => (
  <Image
    width={942}
    height={186}
    src={src}
    alt='Cruz.com Logo'
    aria-hidden='true'
    priority={false}
    unoptimized={true}
    className={twMerge(className, size)}
  />
))

export const Logo = memo(({ className, size, ...rest }: Props) => {
  return (
    <div className={twMerge('flex justify-center', className)} {...rest}>
      <NextLink hrefLang='en' href='/' title='Cruz.com Home' aria-label='Cruz.com Home'>
        <LogoImage src='/img/cruz-logo.svg' className='block dark:hidden' size={size} />
        <LogoImage src='/img/cruz-logo-rev.svg' className='hidden dark:block dark:opacity-80' size={size} />
      </NextLink>
    </div>
  )
})
